import React , { Component } from 'react';
import {injectIntl} from 'react-intl';

import HeaderToolbar from './HeaderToolbar';
import MainMenu from './MainMenu';
import MainMenuToggler from './MainMenuToggler';
import StatsLogo from '../StatsLogo';
import Radium from 'radium';
import RegistryLogo from '../RegistryLogo';


const styles = {
    'nav': {
      backgroundImage:'none',
      backgroundColor: '#004368'
    },

    'title': {
        paddingTop: "10px",
        color: 'white',
        float: "left",
        fontSize: "200%"
    },

    'logo': {
        height: "35px",
        float: 'left',
        marginTop: '5px',
        marginLeft: '25px',
        marginRight: '20px',
    }
}


class Header extends Component {

  render() {
    return(
        <header>
            <nav style={styles.nav} className="navbar navbar-default navbar-fixed-top">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <MainMenuToggler />
                        <a href="/" >
                            <StatsLogo style={styles.logo}/>
                        </a>
                        <div style={styles.title}>Portale Statistiche Registro<RegistryLogo /></div>
                    </div>
                    <div className="navbar-collapse navbar-collapse-pf-site collapse">
                        <HeaderToolbar  {...this.props} />

                    </div>
                </div>
            </nav>
            <MainMenu  {...this.props} />
        </header>
      )
  }
}


export default Radium(injectIntl(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js